import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_CONFIG } from '../constants/i18nConfig';
import './LanguageSwitch.css';

export default function LanguageSwitch() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  if (!I18N_CONFIG.showLanguageSwitch) return null;

  const LANGS = useMemo(
    () => ([
      { value: 'es', label: 'Español', code: 'ES' },
      { value: 'ar', label: 'العربية', code: 'AR' },
      { value: 'zh', label: '中文', code: 'ZH' },
      { value: 'fr', label: 'Français', code: 'FR' },
      { value: 'en', label: 'English', code: 'EN' },
    ]),
    []
  );

  const selected = LANGS.find((l) => l.value === current) || LANGS[0];

  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    function onDocMouseDown(e) {
      if (!open) return;
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    function onKeyDown(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', onDocMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onDocMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const change = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  return (
    <div className="lang-switch" ref={rootRef}>
      <button
        type="button"
        className="lang-switch__trigger"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={t('settings.language') || 'Language'}
        onClick={() => setOpen((v) => !v)}
      >
        <i className="ri-global-line lang-switch__icon" aria-hidden="true" />
        <span className="lang-switch__label">{selected.label}</span>
        <i
          className={`ri-arrow-down-s-line lang-switch__chev ${open ? 'lang-switch__chev--open' : ''}`}
          aria-hidden="true"
        />
      </button>

      {open && (
        <div className="lang-switch__menu" role="menu" aria-label={t('settings.language') || 'Language'}>
          {LANGS.map((l) => (
            <button
              key={l.value}
              type="button"
              role="menuitemradio"
              aria-checked={current === l.value}
              className={`lang-switch__item ${current === l.value ? 'lang-switch__item--active' : ''}`}
              onClick={() => change(l.value)}
            >
              <span>{l.label}</span>
              <span className="lang-switch__item-right">{l.code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
